/**
 * Touch Device Double Tap To Go - Vanilla Javascript
 * @author Chun-Pin Chen <c.chen@techdivision.com>
 * @copyright Copyright (c) 2021 TechDivision GmbH. All rights reserved
 */

function doubleTapToGo(items) {
    if (
        !('ontouchstart' in window) &&
        !navigator.msMaxTouchPoints &&
        !navigator.userAgent.toLowerCase().match(/windows phone os 7/i)
    )
        return false

    var curItem = false

    function touchHandler(e) {
        var resetItem = true
        var clickedTarget = e.target

        if (clickedTarget == curItem) {
            resetItem = false
        }

        if (resetItem) {
            curItem = false
        }
    }

    items.forEach(function (item) {
        item.addEventListener('click', function (e) {
            var item = this

            if (item != curItem) {
                e.preventDefault()
                curItem = item
            }
        })

        document.addEventListener('click', touchHandler, false)
        document.addEventListener('touchstart', touchHandler, false)
        document.addEventListener('MSPointerDown', touchHandler, false)
    })
    return this
}

/**
 * global availability
 */
window.Energy = window.Energy || {}
window.Energy.doubleTapToGo = doubleTapToGo
